import CycleSettings from '../../enums/cycle-setting.enum';
import { IDbCycleSettings } from '../../store/models/cycles';
import { IPostWeldRecipeStep, IPostWeldSettings, PreHeatSettingsEditable } from '../../types/cycle-settings-types';
import { IRecipeEditable, IRecipeStepEditable } from '../../types/recipes-types';

export const convertPostWeldStepToEditable = (step: IPostWeldRecipeStep): IRecipeStepEditable => {
  return {
    mode: step.mode.value,
    durationDays: step.durationDays.value,
    durationHours: step.durationHours.value,
    durationMinutes: step.durationMinutes.value,
    durationMinutesTotal: step.durationMinutesTotal.value,
    heatingRate: step.heatingRate.value,
    heatingLimit: step.heatingLimit.value,
    order: step.order.value,
    isCelsius: step.isCelsius,
  };
};


export const convertPostWeldRecipeToEditable = (recipe: IPostWeldSettings): IRecipeEditable=>{
  return {
    name: recipe.recipeName.value,
    rateUpperTolerance: recipe.upperRampTolerance.value,
    rateLowerTolerance: recipe.lowerRampTolerance.value,
    holdUpperTolerance: recipe.upperHoldTolerance.value,
    holdLowerTolerance: recipe.lowerHoldTolerance.value,
  }
}

export const convertRecipeToPostWeldSettings = (recipe: IDbCycleSettings): IRecipeEditable=>{
  return {
    name: recipe.name,
    rateUpperTolerance: recipe.rateUpperTolerance,
    rateLowerTolerance: recipe.rateLowerTolerance,
    holdUpperTolerance: recipe.holdUpperTolerance,
    holdLowerTolerance: recipe.holdLowerTolerance,
    mode: CycleSettings.PostWeld,
  }
}

export const convertRecipeToPreHeatSettings = (recipe: IDbCycleSettings): PreHeatSettingsEditable=>{
  return {
    soakLower: recipe.soakLower,
    soakUpper: recipe.soakUpper,
    rate: recipe.rate,
    finalTemp: recipe.finalTemp,
  }
}